/** Amount parsing: signs, parentheses, thousands separators, EU decimals, currency detection. */

export function parseAmount(input: string | undefined): number | null {
  if (input == null) return null;
  let s = String(input).trim();
  if (s === '') return null;
  let negative = false;
  if (/^\(.*\)$/.test(s)) {
    negative = true;
    s = s.slice(1, -1);
  }
  s = s.replace(/[^0-9.,-]/g, '');
  if (s === '' || s === '-') return null;
  if (s.startsWith('-')) {
    negative = true;
    s = s.slice(1);
  }
  // European format: 1.234,56
  if (/,\d{2}$/.test(s) && s.includes('.')) s = s.replace(/\./g, '').replace(',', '.');
  else if (/,\d{2}$/.test(s) && !s.includes('.')) s = s.replace(',', '.');
  else s = s.replace(/,/g, '');
  const n = parseFloat(s);
  if (isNaN(n)) return null;
  return negative ? -n : n;
}

const CURRENCY_TOKENS: [RegExp, string][] = [
  [/\$|USD/, 'USD'],
  [/€|EUR/, 'EUR'],
  [/£|GBP/, 'GBP'],
  [/CHF/, 'CHF'],
  [/¥|JPY/, 'JPY'],
  [/CAD/, 'CAD'],
  [/AUD/, 'AUD'],
  [/SEK/, 'SEK'],
  [/NOK/, 'NOK'],
  [/DKK/, 'DKK'],
  [/PLN|zł/, 'PLN'],
  [/RON|lei/i, 'RON'],
];

/** Infer the file's currency from raw amount strings; null when nothing recognizable. */
export function detectCurrency(rawAmounts: string[]): string | null {
  for (const raw of rawAmounts) {
    for (const [re, code] of CURRENCY_TOKENS) {
      if (re.test(raw)) return code;
    }
  }
  return null;
}
